// Login.js
import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import './Style/Login.css';
import useUsersData from './AllUsers';
import emailjs from '@emailjs/browser';
import TopNavbar from '../home/TopNavbar';
import { API_CONFIG } from './../config'; 


const UPDATE_USER = `${API_CONFIG.BASE_URL}${API_CONFIG.ENDPOINTS.LOGINUPDATE}`;


const Login = () => {
    const navigate = useNavigate();
    const [inputEmail, setInputEmail] = useState('');
    const [inputOtp, setInputOtp] = useState('');
    const [generatedOtp, setGeneratedOtp] = useState(null);
    const [step, setStep] = useState(1);
    const [loginStatus, setLoginStatus] = useState(null);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [timer, setTimer] = useState(60);
    const [canResend, setCanResend] = useState(false);
    const [saveLoginId, setSaveLoginId] = useState('');
    const { users, loading } = useUsersData();
    const phoneFromStorage = localStorage.getItem('userPhone');
    const [autoOtp, setAutoOtp] = useState('');

    const testingEmail = [
        "sarwartesting93390@gmail.com",
        "sarwartesting93391@gmail.com",
        "sarwartesting93392@gmail.com",
        "sarwartesting93393@gmail.com",
    ];
    const [formData, setFormData] = useState({
        phone: "",
        name: "",
        class: "",
        login_no: "2",
        login_num: "0",
        first_login_id: "",
        second_login_id: "",
    });

    if (phoneFromStorage) {
        navigate('/');
    }

    useEffect(() => {
        let intervalId = null;
        if (step === 2 && timer > 0) {
            intervalId = setInterval(() => {
                setTimer((prevTime) => prevTime - 1);
            }, 1000);
        } else if (timer === 0) {
            setCanResend(true);
        }
        return () => {
            if (intervalId) clearInterval(intervalId);
        };
    }, [step, timer]);

    const formatTime = (seconds) => {
        const minutes = Math.floor(seconds / 60);
        const remainingSeconds = seconds % 60;
        return `${minutes}:${remainingSeconds < 10 ? '0' : ''}${remainingSeconds}`;
    };

    const handleEmailChange = (e) => {
        setInputEmail(e.target.value);
        setLoginStatus(null);
    };

    const handleOtpChange = (e) => {
        const numbersOnly = e.target.value.replace(/\D/g, '');
        setInputOtp(numbersOnly);
        setLoginStatus(null);
    };

    // EmailJS Sender Helper
    const sendEmailRequest = async (name, email, otp) => {
        const templateParams = {
            user_name: name,
            user_email: email,
            otp_code: otp,
        };

        try {
            await emailjs.send(
                'smtp_neetmocktest',
                'template_o1vyyag',
                templateParams,
                'jUvd--34SL9HJf4eK'
            );
            return true;
        } catch (error) {
            console.error("Email Delivery Failed:", error);
            return false;
        }
    };

    const handleSendOtp = async (e) => {
        e.preventDefault();

        const targetUser = users.find(user => user.email && user.email.toLowerCase() === inputEmail.trim().toLowerCase());

        if (targetUser) {
            const login_no = targetUser?.login_no;
            const login_num = targetUser?.login_num;
            const firstTargetUserId = targetUser?.first_login_id;
            const secondTargetUserId = targetUser?.second_login_id;
            const timestamp = `${Date.now()}_${Math.floor(Math.random() * 1000)}`;

            let updatedPayload = {};

            if (Number(login_no) === 2) {
                updatedPayload = {
                    phone: targetUser.phone,
                    name: targetUser.name,
                    class: targetUser.class,
                    login_no: "1",
                    login_num: login_num + 1,
                    first_login_id: timestamp,
                    second_login_id: secondTargetUserId || "",
                };
                setSaveLoginId(timestamp);
            } else {
                updatedPayload = {
                    phone: targetUser.phone,
                    name: targetUser.name,
                    class: targetUser.class,
                    login_no: "2",
                    login_num: login_num + 1,
                    first_login_id: firstTargetUserId || "",
                    second_login_id: timestamp,
                };
                setSaveLoginId(timestamp);
            }

            setFormData(updatedPayload);


            //  const newOtp = Math.floor(1000 + Math.random() * 9000).toString();
            // setGeneratedOtp(newOtp);

            //  const isTestAccount = inputEmail.toLowerCase() === testingEmail;

            const isTestAccount = testingEmail.includes(inputEmail.toLowerCase());

            // If test account, use fixed OTP, otherwise generate random OTP
            const newOtp = isTestAccount ? "2435" : Math.floor(1000 + Math.random() * 9000).toString();
            setGeneratedOtp(newOtp);


            if (isTestAccount) {
                // For test account: Auto-fill OTP and skip sending email
                setAutoOtp(newOtp);
                setInputOtp(newOtp);

                // Skip email sending and go directly to OTP step
                setStep(2);
                setTimer(60);
                setCanResend(false);
                setLoginStatus(null);
            } else {
                // For other accounts: Clear auto-fill and send email
                setAutoOtp('');
                setInputOtp('');

                setLoginStatus('sending-email');
                const isEmailSent = await sendEmailRequest(targetUser.name, inputEmail, newOtp);

                if (isEmailSent) {
                    setStep(2);
                    setTimer(60);
                    setCanResend(false);
                    setLoginStatus(null);
                } else {
                    setLoginStatus('email-failed');
                }
            }
        } else {
            setLoginStatus('error');
        }
    };

    const handleResendOtp = async () => {
        if (!canResend) return;

        const targetUser = users.find(user => user.email && user.email.toLowerCase() === inputEmail.trim().toLowerCase());
        const userName = targetUser ? targetUser.name : "User";


        // const isTestAccount = inputEmail.toLowerCase() === testingEmail;
        const isTestAccount = testingEmail.includes(inputEmail.toLowerCase());

        // If test account, use fixed OTP, otherwise generate random OTP
        const newOtp = isTestAccount ? "2435" : Math.floor(1000 + Math.random() * 9000).toString();
        setGeneratedOtp(newOtp);

        // const newOtp = Math.floor(1000 + Math.random() * 9000).toString();
        // setGeneratedOtp(newOtp);
        setInputOtp('');
        setLoginStatus('sending-email');

        // Check if it's the test account
        //   const isTestAccount = inputEmail.toLowerCase() === testingEmail;

        if (isTestAccount) {
            // For test account: Auto-fill OTP and skip sending email
            setAutoOtp(newOtp);
            setInputOtp(newOtp);
            setTimer(60);
            setCanResend(false);
            setLoginStatus(null);
        } else {
            // For other accounts: Clear auto-fill and send email
            setAutoOtp('');

            const isEmailSent = await sendEmailRequest(userName, inputEmail, newOtp);

            if (isEmailSent) {
                setTimer(60);
                setCanResend(false);
                setLoginStatus(null);
            } else {
                setLoginStatus('email-failed');
            }
        }
    };

    const setCookie = (name, value, daysActive) => {
        const date = new Date();
        date.setTime(date.getTime() + (daysActive * 24 * 60 * 60 * 1000 * 30));
        const expires = "expires=" + date.toUTCString();
        document.cookie = `${name}=${value}; ${expires}; path=/; SameSite=Strict`;
    };

    const handleVerifyOtp = async (e) => {
        e.preventDefault();

        if (inputOtp === generatedOtp) {
            setIsSubmitting(true);
            try {
                const response = await fetch(UPDATE_USER, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify(formData),
                });

                const data = await response.json();

                if (!response.ok) {
                    throw new Error(data.message || "Update failed");
                }

                setLoginStatus('success');
                localStorage.setItem('userPhone', formData.phone);
                localStorage.setItem('userEmail', inputEmail);
                localStorage.setItem('userName', formData.name);
                localStorage.setItem('userClass', formData.class);
                localStorage.setItem('userId', saveLoginId);
                setCookie('userPhone', formData.phone, 12);
                setCookie('userEmail', inputEmail, 12);
                setCookie('userName', formData.name, 12);
                setCookie('userClass', formData.class, 12);
                setCookie('userId', saveLoginId, 12);

                setTimeout(() => {
                    navigate('/');
                }, 1000);
            } catch (error) {
                console.error("Database update error:", error);
                setLoginStatus('Something-wrong');
            } finally {
                setIsSubmitting(false);
            }
        } else {
            setLoginStatus('wrong-otp');
        }
    };

    return (
        <div className="login-container">
            <TopNavbar name="Login" />
            <div className="login-card">
                {step === 1 && (<>
                    <br></br>
                    <h2>Please Login</h2>
                    <p className="login-subtitle">Enter your email Id to login</p>
                </>)}

                {loading ? (
                    <p className="loading-text">Please wait...</p>
                ) : (
                    <div className="form-wrapper">
                        {step === 1 && (
                            <form onSubmit={handleSendOtp} className="login-form">
                                <div className="form-group">
                                    <label htmlFor="loginEmail">Email Address</label>
                                    <div className="input-wrapper">
                                        <span className="phone-icon">✉️</span>
                                        <input
                                            type="email"
                                            id="loginEmail"
                                            name="email"
                                            value={inputEmail}
                                            onChange={handleEmailChange}
                                            placeholder="Enter registered email"
                                            required
                                            disabled={loginStatus === 'sending-email'}
                                        />
                                    </div>
                                </div>

                                <button
                                    type="submit"
                                    className="login-btn"
                                    disabled={!inputEmail || loginStatus === 'sending-email'}
                                >
                                    {loginStatus === 'sending-email' ? 'Sending Email OTP...' : 'Send OTP'}
                                </button>
                            </form>
                        )}

                        {step === 2 && (
                            <form onSubmit={handleVerifyOtp} className="login-form">
                                <div className="otp-sent-message" style={{
                                    background: '#e6f4ea',
                                    color: '#137333',
                                    padding: '12px',
                                    borderRadius: '6px',
                                    textAlign: 'center',
                                    marginBottom: '16px',
                                    fontSize: '14px',
                                    fontWeight: '500'
                                }}>
                                    📩 OTP sent to your email: {inputEmail}
                                </div>

                                <div className="form-group">
                                    <label htmlFor="otpInput">Enter 4-Digit OTP</label>
                                    <div className="input-wrapper">
                                        <span className="phone-icon">🔒</span>
                                        <input
                                            type="text"
                                            id="otpInput"
                                            value={inputOtp}
                                            onChange={handleOtpChange}
                                            placeholder="Enter OTP"
                                            maxLength="4"
                                            required
                                            disabled={loginStatus === 'success' || isSubmitting || loginStatus === 'sending-email'}
                                            autoComplete="one-time-code"
                                            inputMode="numeric"
                                            pattern="[0-9]*"
                                        />
                                    </div>
                                </div>

                                <div className="timer-wrapper" style={{ margin: '12px 0', fontSize: '14px', textAlign: 'right' }}>
                                    {canResend ? (
                                        <span
                                            onClick={handleResendOtp}
                                            className="resend-link"
                                            style={{ color: '#007bff', cursor: 'pointer', fontWeight: 'bold', textDecoration: 'underline' }}
                                        >
                                            {loginStatus === 'sending-email' ? 'Sending...' : 'Resend OTP'}
                                        </span>
                                    ) : (
                                        <span style={{ color: '#666' }}>
                                            Resend OTP in: <strong>{formatTime(timer)}</strong>
                                        </span>
                                    )}
                                </div>

                                <button
                                    type="submit"
                                    className="login-btn"
                                    disabled={
                                        inputOtp.length !== 4 ||
                                        loginStatus === 'success' ||
                                        isSubmitting ||
                                        loginStatus === 'sending-email'
                                    }
                                >
                                    {isSubmitting ? 'Processing...' : loginStatus === 'success' ? 'Please wait...' : 'Verify & Log In'}
                                </button>
                            </form>
                        )}

                        {/* Status messages */}
                        {loginStatus === 'success' && (
                            <div className="status-box success">🎉 Please wait...</div>
                        )}

                        {loginStatus === 'sending-email' && (
                            <div className="status-box processing" style={{ color: '#666', textAlign: 'center', margin: '10px 0' }}>
                                ⏳ Sending OTP to your email...
                            </div>
                        )}

                        {loginStatus === 'email-failed' && (
                            <div className="status-box error" style={{ color: 'red', textAlign: 'center', margin: '10px 0' }}>
                                ❌ Failed to dispatch email. Please check your network connection.
                            </div>
                        )}

                        {loginStatus === 'error' && (
                            <div className="status-box error">
                                Account not found.
                                <p>Please signUp? <Link to="/signup" className="signup-link">Sign Up</Link></p>
                            </div>
                        )}

                        {loginStatus === 'Something-wrong' && (
                            <div className="status-box error">
                                Something went wrong please try again later.
                            </div>
                        )}

                        {loginStatus === 'wrong-otp' && (
                            <div className="status-box error">
                                Invalid OTP.
                            </div>
                        )}

                        {step === 1 && (<>
                            <div className="login-footer">
                                <p>Don't have an account? <Link to="/signup" className="signup-link">Sign Up</Link></p>
                            </div>
                        </>)}
                    </div>
                )}
            </div>
        </div>
    );
};

export default Login;